import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { FollowupState } from '../../types'

export const createFollowupAction = createAsyncAction(
  '@followup/CREATE_FOLLOWUP_REQUEST',
  '@followup/CREATE_FOLLOWUP_SUCCESS',
  '@followup/CREATE_FOLLOWUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: FollowupState): FollowupState => ({
  ...state,
  isLoadingCreateFollowup: true,
  isSuccessOnCreateFollowup: false,
  isErrorOnCreateFollowup: false
})

const success = (state: FollowupState, action: ActionType<typeof createFollowupAction.success>): FollowupState => ({
  ...state,
  isLoadingCreateFollowup: false,
  isSuccessOnCreateFollowup: true
})

const failure = (state: FollowupState, action: ActionType<typeof createFollowupAction.failure>): FollowupState => ({
  ...state,
  isLoadingCreateFollowup: false,
  isErrorOnCreateFollowup: true
})

export const createFollowupHandle = { asyncAction: createFollowupAction, request, success, failure }
